import React from 'react'
import { t } from 'i18next'

import AssetPreviewCell from './AssetPreviewCell'

import { isProductValid } from '../../../TableActions/AddProductBulk/AddProductBulkContent/AddProductBulkTable/AddProductBulkTableData/helpers'

import { SORT_PARAMETERS } from '../../const/sort'
import { PRODUCT_CUSTOM_TEXT } from '../../../../fields'
import { assetColStyles } from '../../const/tableColumnsSize'

const AssetCol = ({ classes, handleSortChange }) => ({
  header: () => {
    return (
      <div>
        <div>{t('Asset ID')}</div>
        <div>{t('Asset')}</div>
      </div>
    )
  },
  headClassName: classes.quotationBuilderCol,
  className: classes.quotationBuilderCol,
  style: assetColStyles,
  sortParameter: SORT_PARAMETERS.ASSET,
  onSortingChange: handleSortChange,
  Cell: productValues => {
    const isInvalid = !productValues.isInventoryLoading && !isProductValid(productValues)
    return (
      <AssetPreviewCell
        productData={productValues.data}
        isInvalid={isInvalid}
        customText={productValues[PRODUCT_CUSTOM_TEXT]}
      />
    )
  }
})

export default AssetCol
